import { render, staticRenderFns } from "./SideNavDelivery.vue?vue&type=template&id=93fbbcdc"
import script from "./SideNavDelivery.vue?vue&type=script&lang=js"
export * from "./SideNavDelivery.vue?vue&type=script&lang=js"
import style0 from "./SideNavDelivery.vue?vue&type=style&index=0&id=93fbbcdc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports